// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tg {
  border-collapse: collapse;
  border-spacing: 0;
  border-color: var(--border-color);
  width: 100%;
}
.tg.hideTable {
  display: none;
}
.tg td {
  font-family: Arial, sans-serif;
  font-size: 14px;
  padding: 10px 5px;
  border-style: solid;
  border-width: 0px;
  overflow: hidden;
  word-break: normal;
  border-color: var(--border-color);
  color: #333;
  background-color: var(--color-white);
}
.tg th {
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-weight: normal;
  padding: 10px 5px;
  border-style: solid;
  border-width: 0px;
  overflow: hidden;
  word-break: normal;
  border-color: var(--border-color);
  color: #333;
  background-color: var(--color-mainBg);
}
.tg .line {
  float: left;
  width: 100px;
  height: 16px;
  margin-top: 12px;
  border-radius: 7px;
  background-image: linear-gradient(90deg, var(--color-mainBg) 0px, rgba(229, 229, 229, 0.8) 40px, var(--color-mainBg) 80px);
  background-size: 600px;
  animation: shine-lines 2s infinite ease-out;
}

@keyframes shine-lines {
  0% {
    background-position: -100px;
  }
  40%, 100% {
    background-position: 140px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/SkeletonLoader/SkeletonLoader.scss"],"names":[],"mappings":"AAeA;EACE,yBAAA;EACA,iBAAA;EACA,iCAAA;EACA,WAAA;AAdF;AAeE;EACE,aAAA;AAbJ;AAeE;EACE,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,WAAA;EACA,oCAAA;AAbJ;AAeE;EACE,8BAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,WAAA;EACA,qCAAA;AAbJ;AAeE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EA9CF,0HAAA;EAMA,sBAAA;EA2CE,2CAAA;AAbJ;;AAgBA;EACE;IACE,2BAAA;EAbF;EAeA;IAEE,0BAAA;EAdF;AACF","sourcesContent":["$base-color: var(--color-mainBg);\n$shine-color: rgba(229, 229, 229, 0.8);\n$animation-duration: 2s;\n$avatar-offset: 52 + 16;\n\n// this unfortunately uses set px widths for the background-gradient, I never got around to changing it to work with all widths :(\n@mixin background-gradient {\n  background-image: linear-gradient(\n    90deg,\n    $base-color 0px,\n    $shine-color 40px,\n    $base-color 80px\n  );\n  background-size: 600px;\n}\n.tg {\n  border-collapse: collapse;\n  border-spacing: 0;\n  border-color: var(--border-color);\n  width: 100%;\n  &.hideTable{\n    display: none;\n  }\n  td {\n    font-family: Arial, sans-serif;\n    font-size: 14px;\n    padding: 10px 5px;\n    border-style: solid;\n    border-width: 0px;\n    overflow: hidden;\n    word-break: normal;\n    border-color: var(--border-color);\n    color: #333;\n    background-color: var(--color-white);\n  }\n  th {\n    font-family: Arial, sans-serif;\n    font-size: 14px;\n    font-weight: normal;\n    padding: 10px 5px;\n    border-style: solid;\n    border-width: 0px;\n    overflow: hidden;\n    word-break: normal;\n    border-color: var(--border-color);\n    color: #333;\n    background-color: var(--color-mainBg);\n  }\n  .line {\n    float: left;\n    width: 100px;\n    height: 16px;\n    margin-top: 12px;\n    border-radius: 7px;\n\n    @include background-gradient;\n    animation: shine-lines $animation-duration infinite ease-out;\n  }\n}\n@keyframes shine-lines {\n  0% {\n    background-position: -100px;\n  }\n  40%,\n  100% {\n    background-position: 140px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
